<div>
  <udex-tab-navigation size-more-button="Small" tab-width="Medium">
    <udex-tab href="/test/transactions" text="SAP4Me Upsell (Account Determination)" [selected]="selectedTab === 'transactions'"></udex-tab>
    <udex-tab href="/test/product-determination" text="Sap.com PDP (Product Determination)" [selected]="selectedTab === 'product-determination'"></udex-tab>
    <udex-tab href="/test/cta-validation" text="Configurator (CTA Validation)" [selected]="selectedTab === 'cta-validation'"></udex-tab>
    <udex-tab href="/test/products" text="Products" [selected]="selectedTab === 'products'"></udex-tab>
  </udex-tab-navigation>
</div>
